import { API_PATH } from '../constants.js';

const deviceUUID = globalThis.device_uuid;

const logMessage = ({ level = 'info', message }) => {
  console.log(`Device log - level: ${level}, message: ${message}`);
  if (!deviceUUID) return;
  const timestamp = new Date().toISOString();

  fetch(`${API_PATH}/hardware_devices/${deviceUUID}/log`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ timestamp, level, message })
  }).catch(error => {
    console.error('Failed to send device log:', error);
  });
};

console.deviceLogInfo = message => logMessage({ level: 'info', message });
console.deviceLogWarning = message => logMessage({ level: 'warn', message });
console.deviceLogError = message => logMessage({ level: 'error', message });
console.deviceLogDebug = message => logMessage({ level: 'debug', message });
